"use strict";

var _classCallCheck = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var idlUtils = require("../generated/utils.js");

var _require = require("../helpers/namespaces"),
    HTML_NS = _require.HTML_NS;

exports.implementation = /*#__PURE__*/function () {
  function HTMLCollectionImpl(args, privateData) {
    _classCallCheck(this, HTMLCollectionImpl);

    this._list = [];
    this._version = -1;
    this._element = privateData.element;
    this._query = privateData.query;

    this._update();
  }

  _createClass(HTMLCollectionImpl, [{
    key: "item",
    value: function item(index) {
      this._update();

      return this._list[index] || null;
    }
  }, {
    key: "namedItem",
    value: function namedItem(key) {
      if (key === "") {
        return null;
      }

      this._update();

      var _iterator = _createForOfIteratorHelper(this._list),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var element = _step.value;

          if (element.getAttribute("id") === key) {
            return element;
          }

          if (element._namespaceURI === HTML_NS) {
            var name = element.getAttribute("name");

            if (name === key) {
              return element;
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return null;
    }
  }, {
    key: "_update",
    value: function _update() {
      if (this._version < this._element._version) {
        var snapshot = this._query();

        for (var i = 0; i < snapshot.length; i++) {
          this._list[i] = snapshot[i];
        }

        this._list.length = snapshot.length;
        this._version = this._element._version;
      }
    }
  }, {
    key: Symbol.iterator,
    // Inherit some useful functions from Array.
    value: function value() {
      this._update();

      return this._list[Symbol.iterator]();
    }
  }, {
    key: "entries",
    value: function entries() {
      this._update();

      return this._list.entries();
    }
  }, {
    key: "filter",
    value: function filter() {
      var _this$_list;

      this._update();

      return (_this$_list = this._list).filter.apply(_this$_list, arguments);
    }
  }, {
    key: "map",
    value: function map() {
      var _this$_list2;

      this._update();

      return (_this$_list2 = this._list).map.apply(_this$_list2, arguments);
    }
  }, {
    key: "indexOf",
    value: function indexOf() {
      var _this$_list3;

      this._update();

      return (_this$_list3 = this._list).indexOf.apply(_this$_list3, arguments);
    }
  }, {
    key: "length",
    get: function get() {
      this._update();

      return this._list.length;
    }
  }, {
    key: idlUtils.supportedPropertyIndices,
    get: function get() {
      this._update();

      return this._list.keys();
    }
  }, {
    key: idlUtils.supportedPropertyNames,
    get: function get() {
      this._update();

      var result = new Set();

      var _iterator2 = _createForOfIteratorHelper(this._list),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var element = _step2.value;
          var id = element.getAttribute("id");

          if (id) {
            result.add(id);
          }

          if (element._namespaceURI === HTML_NS) {
            var name = element.getAttribute("name");

            if (name) {
              result.add(name);
            }
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return result;
    }
  }]);

  return HTMLCollectionImpl;
}();